import { Claim } from 'store/types/Claim';
import { SortConfig } from 'store/types/Table';
import { sorter } from 'util/Table';

export enum ClaimsTableActionType {
  SetInitialList = 'SetInitialList',
  UpdateSort = 'UpdateSort',
  UpdateFilter = 'UpdateFilter',
}

export interface ClaimsTableState {
  initialList: Claim[];
  list: Claim[];
  listMyClaims: Claim[];
  listAgainstMeClaims: Claim[];
  listHistoricClaims: Claim[];
  listUnderReviewClaims: Claim[];
  sort: SortConfig<Claim>;
}

export interface ClaimsTableAction {
  type: ClaimsTableActionType;
  payload: Partial<ClaimsTableState>;
}

const getSortedList = (list: Claim[] = [], sort: SortConfig<Claim>): Claim[] =>
  list.length ? [...list].sort(sorter<Claim>(sort)) : [...list];

export const initialState: ClaimsTableState = {
  initialList: [],
  list: [],
  listMyClaims: [],
  listAgainstMeClaims: [],
  listHistoricClaims: [],
  listUnderReviewClaims: [],
  sort: { column: 'date', direction: 'desc' },
};

const reducer = (state: ClaimsTableState, { type, payload }: ClaimsTableAction): ClaimsTableState => {
  if (type === ClaimsTableActionType.SetInitialList) {
    const { initialList = [] } = payload;

    const list = getSortedList(initialList ?? [], state.sort);

    return {
      ...state,
      initialList,
      list: list ?? [],
    };
  }

  if (type === ClaimsTableActionType.UpdateSort) {
    const { sort = {} } = payload;

    return {
      ...state,
      sort,
      list: getSortedList(state.initialList, sort),
    };
  }

  return state;
};

export default reducer;
